import { apiUrl, getToken, badResponse } from "./api";

export default {
  getAll(controllerId, startIndex, pathpart) {
    const formData = new FormData();
    formData.append('controllerId', controllerId);
    formData.append('token', getToken());
    formData.append('startIndex', startIndex);
    formData.append('itemsPerPage', 20);
    
    return fetch(apiUrl() + '/sterownik/alarms' + ((pathpart) ? '/' + pathpart : '') + '?t=' + new Date().getTime(), {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .catch(() => badResponse());
  },
}